import { history } from '@umijs/max';
import { authManager, AuthSystem } from '@/services/auth/authManager';

export const FORCE_LOGOUT_MESSAGE = '你的權限已被修改，請重新登陸以應用';
export const FORCE_LOGOUT_NOTICE_STORAGE_KEY = 'flashgreen_force_logout_notice';

/**
 * Persist a logout notice so it can be displayed after redirecting to the login page.
 */
export const storeForceLogoutNotice = (message: string = FORCE_LOGOUT_MESSAGE): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.setItem(FORCE_LOGOUT_NOTICE_STORAGE_KEY, message);
  } catch (error) {
    console.warn('[forceLogout] Failed to store logout notice', error);
  }
};

/**
 * Read and clear any pending logout notice.
 */
export const consumeForceLogoutNotice = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = window.sessionStorage.getItem(FORCE_LOGOUT_NOTICE_STORAGE_KEY);
    if (stored) {
      window.sessionStorage.removeItem(FORCE_LOGOUT_NOTICE_STORAGE_KEY);
      return stored;
    }
  } catch (error) {
    console.warn('[forceLogout] Failed to consume logout notice', error);
  }

  return null;
};

/**
 * Clear admin authentication artifacts and redirect the user to the login page.
 */
export const performAdminForceLogout = (redirectPath: string = '/user/login'): void => {
  authManager.clearAuth(AuthSystem.ADMIN);

  if (typeof window === 'undefined') {
    return;
  }

  try {
    history.push(redirectPath);
  } catch (error) {
    console.warn('[forceLogout] history.push failed, falling back to location.href', error);
    window.location.href = redirectPath;
  }
};
